if (!customElements.get('tonsor-carousel')) customElements.define('tonsor-carousel', class extends HTMLElement {
  connectedCallback() {
    if(this.ready) return;
    this.ready=true;
    this.slides=[...this.querySelectorAll('.tc-slide')];this.index=0;
    if(this.slides.length<2)return;
    this.abort=new AbortController();const options={signal:this.abort.signal};
    this.controls=this.querySelector('.tc-carousel-controls');this.controls.hidden=false;
    this.toggle=this.querySelector('[data-toggle]');
    this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.label();
    this.querySelector('[data-prev]').addEventListener('click',()=>this.manual(-1),options);
    this.querySelector('[data-next]').addEventListener('click',()=>this.manual(1),options);
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.label();},options);
    this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.manual(e.key==='ArrowLeft'?-1:1);}},options);
    let start;
    this.addEventListener('touchstart',e=>{start=e.touches[0].clientX;}, {...options,passive:true});
    this.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-start;if(Math.abs(delta)>45)this.manual(delta<0?1:-1);}, {...options,passive:true});
    this.observer=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;});this.observer.observe(this);
    this.timer=setInterval(()=>{if(!this.paused&&this.visible&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show(1);},6000);
  }
  label(){this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;}
  manual(step){this.paused=true;this.label();this.show(step);}
  show(step){this.slides[this.index].hidden=true;this.index=(this.index+step+this.slides.length)%this.slides.length;this.slides[this.index].hidden=false;this.querySelector('[data-count]').textContent=`${this.index+1} / ${this.slides.length}`;}
  disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.ready=false;}
});
